import axios from "axios";
import { redirect } from "react-router-dom";

const http = axios.create({
  baseURL: process.env.REACT_APP_REST_URL,
  timeout: 3500000,
  headers: {
    "Content-Type": "application/json",
  },
});

http.interceptors.request.use((config) => {
  return config;
});

http.interceptors.response.use((res) => {
  if (res.status === 401 || res.status === 403) {
    redirect("/docView");
  }

  return res;
});

export default http;
